module.exports = __webpack_public_path__ + "img/vg.svg";